import React from 'react'
import type { UploadProvider } from 'types/upload'
import providerConfig from 'components/common/upload/config'
import { Card, Flex, Text } from 'components/ds'
import Icon from 'components/ui/icon'
type Props = {
  provider: UploadProvider
  onClick: (provider: UploadProvider) => void
}
const SIZE = '50px'

const ProviderButton = ({ provider, onClick }: Props): React.ReactNode => {
  const config = providerConfig[provider.id]
  if (!config) return null
  return (
    <Card variant="classic" asChild>
      <button onClick={() => onClick(provider)}>
        <Flex
          direction="column"
          gap="1"
          align="center"
          justify="center"
          width={SIZE}
          height={SIZE}
        >
          <Icon type={config.icon} color={config.color} />
          <Text size="1" align="center">
            {provider.title}
          </Text>
        </Flex>
      </button>
    </Card>
  )
}

export default ProviderButton
